import { nodeRegistry } from '../core/NodeRegistry';
import { ColorNode } from './ColorNode';
import { DocumentNode } from './DocumentNode';
import { MaterialNode } from './MaterialNode';
import { RemixNode } from './RemixNode';
import { SkillNode } from './SkillNode';
import { TagNode } from './TagNode';

// Register all nodes
nodeRegistry.register('color', ColorNode);
nodeRegistry.register('document', DocumentNode);
nodeRegistry.register('image', MaterialNode); // Using 'image' to match existing type usage
nodeRegistry.register('remix', RemixNode);
nodeRegistry.register('skill', SkillNode);
nodeRegistry.register('tag', TagNode);

export { ColorNode, DocumentNode, MaterialNode, RemixNode, SkillNode, TagNode };
